<!--
  Queue layout — header + footer.
  Used by all /customer routes once a session exists; the footer reads
  the verified location from AuthService.metadata.
-->
<div class="customer-shell">
  <app-queue-header />
  <main class="customer-content">
    <router-outlet />
  </main>
  <app-queue-footer />
</div>
